import { DatePicker } from 'antd';

DatePicker.__hasLoad = true;

export default DatePicker;
